// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31KBh","left":"styles_left__34iaQ","desktopActions":"styles_desktopActions__2ikA2","title":"styles_title__1GkUQ"};